<template>
  <div class="uid-intro">
    <div class="popup-shadow"></div>
    <div class="popup-container">
      <a href="javascript:void(0);" class="popup-close" @click="hidePopup"></a>
      <div class="uid-intro-scroll scroll">
        <p class="uid-intro-title1">{{ letter.uidTipTitle }}</p>
        <div class="token-box">
          <p class="token-box-title">
            <span class="text">{{ letter.uidToken }}</span>
          </p>
          <p class="token-box-container">
            <span>3</span><span>3</span><span>3</span><span>3</span>
          </p>
        </div>
        <p class="token-use-1">{{ letter.uidTipIntro1 }}</p>
        <p class="token-use-2">{{ letter.uidTipIntro2 }}</p>
        <p class="uid-intro-title2">{{ letter.uidTipHowToGet }}</p>
        <p class="step-1">{{ letter.uidTipStep1 }}</p>
        <img class="uid-use1" :src="inGameGuideImg" alt="gameGuide" />
        <p class="step-2">{{ letter.uidTipStep2 }}</p>
        <img
          class="uid-use2"
          src="../../../assets/image/officialStore/ztmslg/token.png"
          alt="tokenGuide"
        />
        <p class="step-3">{{ letter.uidTipstep3 }}</p>
        <div class="token-box">
          <p class="token-box-title">
            <span class="text">{{ letter.uidToken }}</span>
          </p>
          <p class="token-box-container">
            <span>3</span><span>3</span><span>3</span><span>3</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'UidTokenGuidePopup',
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),
    inGameGuideImg() {
      return this.gameInfoConfig.uidTokenGuidePopupGameImg
    }
  },
  methods: {
    hidePopup() {
      this.$emit('hidePopup')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.uid-intro {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
}
.popup-container {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  padding: 0 44px 76px;
  width: 90%;
  height: 90%;
  background-size: 100% 100%;
  color: var(--login-uidtoken-guide-popup-tip);
  transform: translate(-50%, -50%);
  @psetbg ('coupon-popup-bg.png', false, false);
}
.popup-close {
  position: absolute;
  right: 36px;
  top: 36px;
  background-size: cover;
  cursor: pointer;
  @psetbg ('close.png');
}
.uid-intro-scroll {
  overflow: auto;
  margin: 76px auto 0;
  height: 95%;
}
.uid-intro-title1 {
  margin: 0 auto 50px;
  text-align: center;
  font-size: 32px;
  color: var(--login-uidtoken-guide-popup-title);
}
.uid-intro-title2 {
  margin: 0 auto 37px;
  text-align: center;
  font-size: 32px;
  color: var(--login-uidtoken-guide-popup-title);
}
.uid-use1 {
  display: block;
  margin: 0 auto 42px;
  width: 364px;
}
.uid-use2 {
  display: block;
  margin: 0 auto 42px;
  width: 513px;
  height: 211px;
}
.token-box {
  overflow: hidden;
  margin: 0 auto 25px;
  border: solid 2px var(--login-uidtoken-guide-popup-otp-border);
  width: 511px;
  height: 241px;
  background: var(--login-uidtoken-guide-popup-otp-bg);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .5);
}
.token-box-title {
  margin-left: 21px;
  margin-top: 19px;
  text-align: left;
}
.token-box-title .text {
  font-size: 24px;
  color: var(--login-uidtoken-guide-popup-otp-title);
}
.token-box-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px auto 0;
  width: 365px;
}
.token-box-container > span {
  display: block;
  border-radius: 5px;
  width: 81px;
  height: 99px;
  background-color: var(--login-uidtoken-guide-popup-otp-num-bg);
  line-height: 99px;
  text-align: center;
  font-weight: 500;
  font-size: 72px;
  color: var(--login-uidtoken-guide-popup-otp-num);
}
.token-use-1 {
  margin-top: 25px;
}
.token-use-2 {
  margin-bottom: 52px;
}
.token-use-1,
.token-use-2 {
  line-height: 32px;
  text-align: left;
  font-size: 18px;
}
.step-1,
.step-2,
.step-3 {
  margin-bottom: 20px;
  text-align: left;
  font-size: 18px;
}
@media screen and (orientation: landscape) {
  .popup-container {
    width: 610px;
  }
  .uid-intro-title1,
  .uid-intro-title2 {
    font-size: 30px;
  }
  .popup-close {
    width: 30px;
    height: 30px;
    @psetbg ('close-hen.png');
  }
}

</style>
